<header>
    <div class="col-12 top-head">
        <div class="col-3 logo">
            <div>
                <div id="block-eboni-branding">
                    <a href="/" rel="home">
                        <img src="assets/images/hayti_logo.png" alt="Home">

                    </a>
                </div>
            </div>
        </div>
        <div class="col-6 menu-box">
            <nav class="navbar navbar-inverse">
                <div class="navbar-collapse collapse" id="myNavbar" aria-expanded="false">
                    <div>
                        <nav role="navigation" aria-labelledby="block-mainnavigation-menu" id="block-mainnavigation">
                            <ul class="menu">
                                <!-- <li><a routerLink="/about-us">About</a></li> -->
                                <li><a routerLink="/publishers">Publishers</a></li>
                                <!-- <li><a routerLink="/podcasts-web">Podcasts</a></li> -->
                                <!-- <li><a routerLink="/news">News</a></li> -->
                                <!-- <li><a routerLink="/podcasts-web">Podcasts Web</a></li> -->
                                <li><a routerLink="/podcasters">Podcasters</a></li>
        
                            </ul>
                        </nav>
                    </div>
                </div>
            </nav>
        </div>
        <div class="col-3 extra-menu">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#myNavbar"
                aria-expanded="false">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span> </button>
        </div>
    </div>
    <div class="col-12 site-inner-banner pl-0 pr-0">
        <div class="container">
            <h1></h1>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 in_main bredcrumb">
        <div>
            <div id="block-eboni-local-tasks">
                <ul>
                    <li><a class="is-active">Log in<span class="visually-hidden"></span></a></li>
                    <li><a class="">Create new account</a></li>
                    <li><a class="">Reset your password</a></li>
                </ul>

            </div>
        </div>
    </div>
</header>
<section class="internal_pages">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12 in_main main-contents-section form-section">
                <div>
                    <div class="hidden"></div>
                    <div id="block-eboni-content">
                        <form class="user-login-form" [formGroup]="loginForm" id="user-login-form"
                            accept-charset="UTF-8">
                            <div class="js-form-item form-item js-form-type-textfield form-item-name js-form-item-name">
                                <label for="edit-name" class="js-form-required form-required">Username</label>

                                <input autocorrect="none" autocapitalize="none" spellcheck="false" autofocus="autofocus"
                                    aria-describedby="edit-name--description" formControlName="username" type="text"
                                    id="edit-name" name="name" value="" size="60" maxlength="60"
                                    class="form-text required" required="required" aria-required="true">

                                <div id="edit-name--description" class="description">
                                    Enter your Hayti - News, Videos and Podcasts from Black Publishers username.
                                </div>
                            </div>

                            <div class="js-form-item form-item js-form-type-password form-item-pass js-form-item-pass">
                                <label for="edit-pass" class="js-form-required form-required">Password</label>
                                <input aria-describedby="edit-pass--description" formControlName="password"
                                    type="password" id="edit-pass" name="pass" size="60" maxlength="128"
                                    class="form-text required" required="required" aria-required="true">

                                <div id="edit-pass--description" class="description">
                                    Enter the password that accompanies your username.
                                </div>
                            </div>

                            <!-- <input autocomplete="off"
                                data-drupal-selector="form-kvnwwqzhcdcdjsqrbnqvxf8uf8pzkk1wnfhtiqogq40" type="hidden"
                                name="form_build_id" value="form-KvnWWQzhcdCdJsqRbNQvXF8Uf8PZKk1WnFHTiqogQ40">


                            <input  type="hidden" name="form_id"
                                value="user_login_form"> -->

                            <div class="form-actions js-form-wrapper form-wrapper" id="edit-actions">


                                <input type="submit" id="edit-submit" name="op" value="Log in"
                                    (click)="loginFormSubmit()" class="button js-form-submit form-submit">

                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>